module.exports = __webpack_public_path__ + "img/profile01.2d007dbe.jpg";